import React from 'react';

import Icons from 'assets/icons';

interface FilterTagProps {
  label: string;
  onRemove: () => void;
}

const FilterTag = ({ label, onRemove }: FilterTagProps) => (
  <span className="inline-flex items-center gap-1 rounded-md border border-navy-200 bg-white px-3 py-1.5 text-sm text-gray-700">
    {label}
    <button
      type="button"
      onClick={onRemove}
      className="ml-1 flex items-center"
      aria-label={`Remove filter ${label}`}
      data-testid={`remove-filter-${label}`}
    >
      <Icons.Plus customClass="w-3.5 h-3.5 rotate-45 text-gray-500" />
    </button>
  </span>
);

export default FilterTag;
